import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Container } from '@chakra-ui/react';
import { PageName } from '@whitbread-eos/api';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContainerComponent(_ref) {
  var children = _ref.children,
    containerStyles = _ref.containerStyles,
    pageName = _ref.pageName;
  var styles = {
    minW: '18.75rem',
    maxW: {
      base: 'none',
      mobile: '100%',
      sm: '100%',
      md: '100%',
      lg: 'var(--chakra-space-breakpoint-lg)',
      xl: 'var(--chakra-space-breakpoint-xl)'
    },
    px: {
      base: 0,
      mobile: '1rem',
      sm: '1.125rem',
      md: '1.5rem',
      lg: '1.75rem',
      xl: '4.125rem'
    }
  };
  var priceFinderStyles = _objectSpread(_objectSpread({}, styles), {}, {
    minW: '100%',
    px: {
      base: 0
    }
  });
  return _jsx(Container, _objectSpread(_objectSpread(_objectSpread({}, styles), pageName === PageName.PRICE_FINDER ? _objectSpread({}, priceFinderStyles) : _objectSpread({}, containerStyles)), {}, {
    children: children
  }));
}